// extracted by mini-css-extract-plugin
export default {"tabWrapper":"LostPassword_tabWrapper__0oyLN"};